const moduleMap = {
	"./ConfigUtils": () => {
		return __webpack_require__.e(1486).then(() => (() => ((__webpack_require__(1486)))));
	},
	"./SharedUtils": () => {
		return __webpack_require__.e(1486).then(() => (() => ((__webpack_require__(1486)))));
	},
	"./SharedStore": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(6530)]).then(() => (() => ((__webpack_require__(8879)))));
	},
	"./SharedStoreProvider": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(6530), __webpack_require__.e(4242)]).then(() => (() => ((__webpack_require__(4242)))));
	},
	"./SharedDynamicModule": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(6530)]).then(() => (() => ((__webpack_require__(8504)))));
	},
	"./DynamicModuleLoader": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(6530)]).then(() => (() => ((__webpack_require__(6895)))));
	},
	"./SharedHooks": () => {
		return Promise.all([__webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(3749), __webpack_require__.e(7656), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(9970), __webpack_require__.e(8781), __webpack_require__.e(3934)]).then(() => (() => ((__webpack_require__(3934)))));
	},
	"./BaseApi": () => {
		return Promise.all([__webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4814), __webpack_require__.e(9970), __webpack_require__.e(9777)]).then(() => (() => ((__webpack_require__(2158)))));
	},
	"./IdentityApiModule": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(3749), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(9970), __webpack_require__.e(6530), __webpack_require__.e(8781), __webpack_require__.e(311)]).then(() => (() => ((__webpack_require__(311)))));
	},
	"./IdentityApi": () => {
		return Promise.all([__webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(3749), __webpack_require__.e(7656), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(9970), __webpack_require__.e(8781), __webpack_require__.e(8775)]).then(() => (() => ((__webpack_require__(8775)))));
	},
	"./CounterModule": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7569), __webpack_require__.e(8502), __webpack_require__.e(4319), __webpack_require__.e(7338), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(3839), __webpack_require__.e(3793), __webpack_require__.e(6530), __webpack_require__.e(3805)]).then(() => (() => ((__webpack_require__(3805)))));
	},
	"./CounterSlice": () => {
		return Promise.all([__webpack_require__.e(605), __webpack_require__.e(4814), __webpack_require__.e(9485)]).then(() => (() => ((__webpack_require__(9485)))));
	},
	"./Loading": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(3076)]).then(() => (() => ((__webpack_require__(3076)))));
	},
	"./Error": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(5932)]).then(() => (() => ((__webpack_require__(5932)))));
	},
	"./Typeahead": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(4689), __webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(5686), __webpack_require__.e(9831), __webpack_require__.e(386), __webpack_require__.e(7862)]).then(() => (() => ((__webpack_require__(7862)))));
	},
	"./FailoverComponent": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7656), __webpack_require__.e(9831), __webpack_require__.e(5549), __webpack_require__.e(1557)]).then(() => (() => ((__webpack_require__(1557)))));
	},
	"./Select": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(4689), __webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(5686), __webpack_require__.e(9831), __webpack_require__.e(386)]).then(() => (() => ((__webpack_require__(386)))));
	},
	"./TextField": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(9831), __webpack_require__.e(7033)]).then(() => (() => ((__webpack_require__(7033)))));
	},
	"./TextArea": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(9831), __webpack_require__.e(6350)]).then(() => (() => ((__webpack_require__(6350)))));
	},
	"./Grid": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(5926)]).then(() => (() => ((__webpack_require__(5926)))));
	},
	"./Card": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(7897)]).then(() => (() => ((__webpack_require__(7897)))));
	},
	"./Table": () => {
		return Promise.all([__webpack_require__.e(4040), __webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(4442)]).then(() => (() => ((__webpack_require__(4442)))));
	},
	"./List": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(8814)]).then(() => (() => ((__webpack_require__(8814)))));
	},
	"./StatusIndicator": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(4150)]).then(() => (() => ((__webpack_require__(4150)))));
	},
	"./TextGroup": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(7645)]).then(() => (() => ((__webpack_require__(7645)))));
	},
	"./DropdownMenuContent": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(3838), __webpack_require__.e(250), __webpack_require__.e(4649), __webpack_require__.e(9876)]).then(() => (() => ((__webpack_require__(9876)))));
	},
	"./TooltipContent": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(5908), __webpack_require__.e(3838), __webpack_require__.e(250), __webpack_require__.e(2708), __webpack_require__.e(8269)]).then(() => (() => ((__webpack_require__(8269)))));
	},
	"./usePortalContainer": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(3838), __webpack_require__.e(250), __webpack_require__.e(9329)]).then(() => (() => ((__webpack_require__(9329)))));
	},
	"./PodiumStyleProvider": () => {
		return Promise.all([__webpack_require__.e(7656), __webpack_require__.e(3838), __webpack_require__.e(250)]).then(() => (() => ((__webpack_require__(250)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});